<template>
  <div class="card">

    <Header
      ref="header-section"
      @filter="handleFilterClicked"
      :hasSubAccounts="hasSubAccounts"
      :selectedAds="selectedAdsCount"
      :exportSortModel="exportSortModel"
      :isExportButtonDisabled="isExportButtonDisabled"
      :visibleColumns="visibleColumns" 
    />

    <Table
      ref="adsTable"
      @selected="handleRowSelection"
      @sortChanged="sortChanged"
      @dataChange="isExportButtonDisabled = $event.totalItems === 0"
      @visibleColumnsChanged="updateVisibleColumns"
    />

  </div>
</template>

<script>

import accountsTree from  '@/helpers/accountsTree'
import Header from  './components/header-section.vue'
import Table from './components/table-section'


export default {

  data () {
    return {
      visibleColumns: [],
      isExportButtonDisabled: false,
      exportSortModel: {
        sortBy: 'id',
        isASC: false
      },
      selectedAdsCount: 0,
      hasSubAccounts: false
    }
  },


  async mounted () {
    this.hasSubAccounts = await this.checkIfHasSubAccounts()
  },


  components: {
    Header,
    Table
  },

  methods: {

     updateVisibleColumns(visibleColumns) {
      this.visibleColumns = visibleColumns.map(col => col.colId)
     },
    sortChanged (sortModel) {
      const sortColumn = sortModel[0] || {}

      this.exportSortModel = {
        sortBy: sortColumn.colId,
        isASC: sortColumn.sort === 'asc'
      }
    },

    handleFilterClicked (filters) {
      this.$refs['adsTable'].filter(filters)
    },

    handleRowSelection (selectedRows) {
      const selectedRowsCount = selectedRows.length
      this.selectedAdsCount = selectedRowsCount
    },

    async  checkIfHasSubAccounts () {
      const subAccounts = await accountsTree.loadSubAccounts()
      return subAccounts.length > 1
    }

  }


}

</script>


<style lang="scss" scoped>
  .card {
    background: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 10px;

    @apply px-5 py-8;
  }
</style>

